import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import cardBalancesServices from '@src/services/cardBalances.services';

export const cardBalancesGetList = createAsyncThunk(
  'cardBalancesGetList',
  async ({ body }, { getState, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      return await cardBalancesServices.cardBalancesGetList({ ...body, customerId: customerId });
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const cardBalancesSlice = createSlice({
  name: 'cardBalances',
  initialState: {
    cardBalancesList: false,
  },
  reducers: {
    resetCardBalancesList: (state) => {
      state.cardBalancesList = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(cardBalancesGetList.fulfilled, (state, action) => {
      state.cardBalancesList = action.payload.data || [];
    });
  },
});

export const { resetCardBalancesList } = cardBalancesSlice.actions;
